<template>
  <v-app id="launcher" class="bg">
    <v-navigation-drawer
      v-if="!fullscreen"
      app
      color="#9992"
      bottom
      expand-on-hover
      dark
      data-test="navigation-drawer"
    >
        <div class="d-flex align-center flex-column pt-6">
          <v-tooltip
            v-for="item in navigationItems"
            :key="item.title"
            right
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click.stop=item.action
                :to="{ name: item.route }"
                fab
                dark
                class="my-3"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon v-text="item.icon" />
              </v-btn>
            </template>
            <span>{{ item.caption }}</span>
           </v-tooltip>
          <v-img
            class="mb-2 px-2"
            id="logo"
            contain
            src="@/assets/rf-logo.png"
          />
        </div>
    </v-navigation-drawer>
    <v-main id="iframe-wrapper" class="pa-0">
      <v-btn
        v-if="fullscreen"
        absolute
        color="secondary"
        elevation="12"
        class="ma-2"
        fab
        x-large
        @click.stop="fullScreenToggle"
      >
        <v-icon v-text="'$collapse'" />
      </v-btn>
      <embed
        id="iframe-rfgame"
        :key="iframeKey"
        :src="launcherUrl"
        scrolling="no"
        frameborder=0
        height="100%"
        width="100%"
      />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'Launcher',
  props: {
    game: {
      type: String,
      required: true,
    },
    provider: {
      type: String,
      required: true,
    },
    casino: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    fullscreen: false,
    iframeKey: 0,
    urlPrefix: '', // Change to https://pre.kolyseo.es for testing
  }),
  computed: {
    launcherUrl() {
      return `${this.urlPrefix}/launcher/?gameUid=${this.game}&providerUid=${this.provider}&casinoUid=${this.casino}&lang=es`;
    },
    navigationItems() {
      return [
        {
          caption: 'Return to the lobby',
          icon: '$home',
          route: 'home',
        },
        {
          caption: 'Change to full screen mode',
          icon: '$screen',
          action: this.fullScreenToggle,
        },
        {
          caption: 'Reload this game',
          icon: '$reload',
          action: this.reloadGame,
        },
      ];
    },
  },
  methods: {
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
    fullScreenToggle() {
      this.$fullscreen.toggle(
        this.$el.querySelector('#iframe-wrapper'),
        {
          wrap: false,
          callback: this.fullscreenChange,
        },
      );
    },
    reloadGame() {
      this.iframeKey += 1;
    },
  },
};
</script>

<style scoped lang="scss">
.theme--dark {
  &.v-list-item--active:before {
    opacity: 0;
  }
}
#logo {
  bottom: 0;
  left: 0;
  position: absolute;
}
</style>
